"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticlesDictUtils = void 0;
const ArticleJsonUtils_1 = require("./ArticleJsonUtils");
const echain_product_models_1 = require("@igus/echain-product-models");
class ArticlesDictUtils {
    static create() {
        return {
            [echain_product_models_1.ArticleType.ae]: [],
            [echain_product_models_1.ArticleType.espool]: [],
            [echain_product_models_1.ArticleType.fuehrungsrinne]: [],
            [echain_product_models_1.ArticleType.ia]: [],
            [echain_product_models_1.ArticleType.kette]: [],
            [echain_product_models_1.ArticleType.konfektionierung]: [],
            [echain_product_models_1.ArticleType.leitung]: [],
            [echain_product_models_1.ArticleType.link]: [],
            [echain_product_models_1.ArticleType.montageSet]: [],
            [echain_product_models_1.ArticleType.montBes]: [],
            [echain_product_models_1.ArticleType.verpackung]: [],
            [echain_product_models_1.ArticleType.zugentlastung]: [],
            [echain_product_models_1.ArticleType.espool]: [],
            [echain_product_models_1.ArticleType.zubehoer]: [],
        };
    }
    static addByType(dict, article, articleType) {
        ArticlesDictUtils.add(dict, Object.assign(Object.assign({}, article), { ArticleType: articleType }));
    }
    static add(dict, article) {
        ArticlesDictUtils.getRef(dict, article).push(article);
    }
    static getAllArticle(dict) {
        const articles = [];
        Object.values(dict).forEach((value) => articles.push(...value));
        return articles;
    }
    static find(dict, article) {
        const ref = ArticlesDictUtils.getRef(dict, article).find((a) => ArticleJsonUtils_1.ArticleJsonUtils.areSameArticles(a, article));
        if (ref) {
            return Object.assign(Object.assign({}, ref), { ArticleType: article.ArticleType });
        }
        return undefined;
    }
    static getRef(dict, article) {
        return dict[article.ArticleType];
    }
}
exports.ArticlesDictUtils = ArticlesDictUtils;
//# sourceMappingURL=ArticlesDictUtils.js.map